import React, { useContext } from 'react';
import {
  H3,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@vp/swan';
import { ExperimentsContext } from '../../../experimentation/ExperimentsContext';
import { DebugExperimentsControls } from './DebugExperimentsControls';

export const DebugExperimentsPanel = () => {
  const { overrideExperiment, activeExperiments } =
    useContext(ExperimentsContext);

  if (!activeExperiments || activeExperiments.length < 1) {
    return (
      <div>
        <Typography>It appears you have no active experiments.</Typography>
      </div>
    );
  }

  return (
    <Table skin="dividers">
      <TableCaption>
        <H3 visuallyHidden>Experiments</H3>
      </TableCaption>
      <TableHead>
        <TableRow>
          <TableCell id="mod-family-label">Experiment keys</TableCell>
          <TableCell id="mod-id-label">Variation keys</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {activeExperiments.map((activeExperiment, index) => (
          <TableRow>
            <DebugExperimentsControls
              experimentKey={activeExperiment.experimentKey}
              variationKey={activeExperiment.variationKey}
              availableVariationKeys={activeExperiment.availableVariationKeys}
              overrideExperiment={overrideExperiment}
              key={index}
            />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
